import React from 'react';
import './styles/Hero.css';
import heroBg from '../assets/hero.jpeg'; // Import the image
import hero_mobileBg from '../assets/ckk.jpg'; // Import the image

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // Reduce offset to 0 or small value since header is transparent/overlaying
      window.scrollTo({
        top: section.offsetTop, 
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      id="home" 
      className="hero" 
           // We pass both images as CSS variables here
      style={{ 
        '--hero-bg': `url(${heroBg})`,
        '--hero-mobile-bg': `url(${hero_mobileBg})`
      }}
    >
      {/* Overlay to make text readable on top of image */}
      <div className="hero-overlay"></div> 
      <div className="founders-badge">
        <span className="founded-text">Founded by</span>
        <span className="founder-names">Srujana & Sree Keerthi Valiveti</span>
      </div>

      {/* <div className="hero-content">
        <h1 className="hero-title">
          Grace. Grit.<br/>
          <span className="kalavaanya">Kalavaanya.</span>
        </h1>
        <p className="hero-subtitle">Where ancient tradition meets contemporary expression.</p>
        <p className="hero-founders">Founded by sisters Srujana & Sree Keerthi Valiveti</p>
        
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => scrollToSection('classes')}>
            Join a Class
          </button>
          <button className="btn btn-secondary" onClick={() => scrollToSection('student-zone')}>
            Explore Student Zone
          </button>
        </div>
        
        <blockquote className="hero-quote">
          "Kalavaanya is not just a school — it is a sacred space for becoming."
        </blockquote>
      </div> */}
    </section>
  );
};

export default Hero;
